import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Body from "../components/bodymain"
import About from '../components/about'
import Services from '../components/myservices'
import Skills from '../components/skills'
import Contact from '../components/contact'
import Projects from '../components/myprojects'

import '@fortawesome/fontawesome-svg-core/styles.css';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Body />
    <About />
    <Services />
    <Skills />
    <Projects />
    <Contact />
  </Layout>
)

export default IndexPage
